<ng-container *ngIf="productionScheduleItem?.canBeRecolored(); else nonRecolorableItem">
  <svg:svg *ngIf="productionScheduleItem.isRecolored; else notRecolored" [attr.y]="drawingVerticalPosition" [attr.height]="productionScheduleItemInPathGroupHeight">
    <defs>
      <svg:pattern [attr.id]="productionScheduleItem.uuid" x="0" y="0" width="100%" [attr.height]="drawingImageHeight" patternUnits="userSpaceOnUse">
        <svg:image x="0" y="0" width="100%" [attr.href]="productionScheduleItem.drawing.image.data" height="100%" preserveAspectRatio="none slice" />
      </svg:pattern>
      <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="8" stdDeviation="4" flood-color="#1B1D2226" />
      </filter>
    </defs>
    <ng-container>
      <svg:rect *ngIf="!canShowBorder" width="100%" x="0" height="100%" y="0" [ngStyle]="getPathItemStyle(productionScheduleItem)"></svg:rect>
      <svg:rect
        *ngIf="canShowBorder"
        [attr.width]="getAdjustedWidth(2)"
        x="1"
        [attr.height]="getAdjustedHeight(2)"
        y="1"
        [ngStyle]="getPathItemStyle(productionScheduleItem)"
        stroke="white"
        stroke-width="1"
      ></svg:rect>
      <svg:rect
        *ngIf="canShowBorder"
        [attr.width]="getAdjustedWidth(4)"
        x="2"
        [attr.height]="getAdjustedHeight(4)"
        y="2"
        [ngStyle]="getPathItemStyle(productionScheduleItem)"
        stroke="black"
        stroke-width="1"
      ></svg:rect>
    </ng-container>
    <svg:rect
      *ngIf="canShowProductionScheduleItemPathLabel"
      #productionScheduleItemPathLabelContainer
      class="production-schedule-item-label-container"
      height="50"
      x="25%"
      y="calc(50% - 25px)"
      rx="4"
      ry="4"
      fill="#fff"
      filter="url(#shadow)"
    ></svg:rect>
    <text class="production-schedule-item-label" *ngIf="canShowProductionScheduleItemPathLabel" #productionScheduleItemPathLabel x="50%" y="50%" text-anchor="middle" dominant-baseline="middle">
      <tspan x="50%" dy="-8px" font-weight="bold">{{ productionScheduleItem.drawing.name }}</tspan>
      <tspan x="50%" dy="18px">
        <tspan font-weight="bold">{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}:</tspan>
        {{ getPathItemHeight(productionScheduleItem) }}
      </tspan>
    </text>
  </svg:svg>

  <ng-template #notRecolored>
    <svg:g [attr.height]="productionScheduleItemInPathGroupHeight">
      <svg:rect class="placeholder-for-recolored-drawing-background" width="100%" height="100%"></svg:rect>
      <svg:image
        class="placeholder-for-recolored-drawing"
        href="../assets/images/placeholder-recolored-drawing.svg"
        x="50%"
        y="50%"
        preserveAspectRatio="none slice"
        [attr.width]="getPlaceholderWidthAndHeight()"
        [attr.height]="getPlaceholderWidthAndHeight()"
        [attr.transform]="getPlaceholderPosition()"
      ></svg:image>
    </svg:g>
  </ng-template>

  <svg:rect y="0" class="production-schedule-item-cutbar cutbar-before" [attr.height]="cutbarBeforeHeight"></svg:rect>
  <svg:rect [attr.y]="cutbarAfterVerticalPosition" class="production-schedule-item-cutbar cutbar-after" [attr.height]="cutbarAfterHeight"></svg:rect>
</ng-container>

<ng-template #nonRecolorableItem>
  <svg:svg #diagonalHatch class="non-recolorable-item" width="100%" [attr.y]="drawingVerticalPosition" [attr.height]="productionScheduleItemInPathGroupHeight">
    <defs>
      <pattern id="diagonalHatch" patternUnits="userSpaceOnUse" width="4" height="4" patternTransform="rotate(45)">
        <line x1="0" y="0" x2="0" y2="4" stroke="#DF946A" stroke-width="3" />
      </pattern>
    </defs>
    <svg:rect
      class="non-recolorable-item-background"
      width="100%"
      [attr.height]="productionScheduleItemInPathGroupHeight"
      fill="url(#diagonalHatch)"
      y="0"
      [matTooltip]="getTooltipText(productionScheduleItem)"
      [matTooltipDisabled]="canShowProductionScheduleItemNonRecolorableLabel"
      matTooltipPosition="above"
    ></svg:rect>
    <svg:rect
      *ngIf="canShowProductionScheduleItemNonRecolorableLabel"
      #productionScheduleItemNonRecolorableLabelContainer
      height="32"
      x="25%"
      y="calc(50% - 16px)"
      rx="4"
      ry="4"
      fill="#fff"
      filter="url(#shadow)"
    ></svg:rect>
    <text
      class="production-schedule-item-label"
      *ngIf="canShowProductionScheduleItemNonRecolorableLabel"
      #productionScheduleItemNonRecolorableLabel
      x="50%"
      y="50%"
      text-anchor="middle"
      dominant-baseline="middle"
    >
      <tspan x="50%">
        <tspan font-weight="bold">{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}:</tspan>
        {{ getPathItemHeight(productionScheduleItem) }}
      </tspan>
    </text>
  </svg:svg>
</ng-template>
